var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"kt_header",staticClass:"header header-fixed",attrs:{"id":"kt_header"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrapper rounded-top-xl d-flex flex-grow-1 align-items-center"},[_c('div',{staticClass:"container-fluid d-flex align-items-center justify-content-end justify-content-lg-between flex-wrap"})])
}]

export { render, staticRenderFns }